import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useNavigate } from "react-router-dom";
import JumpMenuActions from "./JumpMenuActions";
import JumpMenuNav from "./JumpMenuNav";
import JumpMenuBranding from "./JumpMenuBranding";
import TopSearch from "./TopSearch";
import { Box, Divider } from "@mui/material";

type JumpMenuProps = {
  open: boolean;
  onClose: () => void;
};

export const JumpMenu: React.FC<JumpMenuProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const [filterText, setFilterText] = React.useState<string>("");

  useEffect(() => {
    if (!open) {
      setFilterText("");
    }
  }, [open]);

  return (

    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: (theme) => ({
            position: "fixed",
            top: theme.spacing(1.5),
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: theme.zIndex.appBar + 1400,
            bgcolor:
              theme.palette.mode === "dark"
                ? "#0f1720"
                : theme.palette.background.paper,
            color: theme.palette.text.primary,
            borderRadius: 2,
            overflow: "hidden",
            width: 488,
            maxWidth: "calc(100% - 32px)",
            margin: 0,
          }),
        },
        backdrop: {
          sx: { backgroundColor: "rgba(0,0,0,0.2)" },
        },
      }}
      aria-labelledby="jump-menu"
    >
      <DialogContent sx={{ p: 2 }}>
        <TopSearch
          autoFocus={open}
          value={filterText}
          onChange={(v) => setFilterText(v)}
          onSubmit={onClose}
        />
        <Box sx={{ paddingRight: 1, maxHeight: 550, overflowY: "auto", mt: 2 }}>
          <JumpMenuActions onClose={onClose} filterText={filterText} />
          <Divider />
          <JumpMenuNav
            onClose={onClose}
            navigate={(p) => navigate(p)}
            filterText={filterText}
            open={open}
          />
        </Box>
        <JumpMenuBranding />
      </DialogContent>
    </Dialog>
  );
};

export default JumpMenu;
